const BrokenComponent = () => {
  throw new Error("This component failed to render!");
};

export default BrokenComponent;
